<template>
  <div v-if="interviewResponse">
    <ComplexInterviewComponent v-if="interviewResponse.complex" :interview-details="interviewResponse.complex"/>
    <SimpleInterviewComponent  v-if="interviewResponse.simple" :interview-details="interviewResponse.simple"/>
  </div>

  <div v-else class="rankingTableWrapper table-responsive">
    <b-form-input v-model="filtertext" placeholder="Filter"></b-form-input>
    <b-table
        class="rankingTable"
        foot-clone
        no-footer-sorting
        responsive
        striped
        hover
        small
        sort-icon-left
        :items="myProvider"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :current-page="currentPage"
        :per-page="rowsPerPage"
        :filter="filtertext"
        :filter-debounce="200"
        show-empty
        :empty-text="$t('RANKINGTABLE_EMPTY_TEXT')"
        :empty-filtered-text="$t('RANKINGTABLE_EMPTY_FILTERED_TEXT')"
        @row-clicked="onRowClicked"
    >

      <template v-slot:head()="data">
            <span v-b-tooltip.hover.leftbottom :title="data.field.tooltip">
                <div v-for="(seg,idx) in splitColumnHeader(data.label)" :key="idx"  >{{seg}}</div>
            </span>
        <div>{{ data.field.subLabel }}</div>
      </template>

      <!-- Default fall-back custom formatted footer cell -->
      <template v-slot:foot()="celldata">
        <template v-if="footerRow!==null && footerRow[celldata.column]">
          <template v-if="footerRow[celldata.column].goal">
            {{ footerRow[celldata.column].svalue }}
            <span class="dot" :style="{ backgroundColor: ballColor(footerRow[celldata.column].goal) }"></span>
          </template>
          <template v-else>
            {{ footerRow[celldata.column] }}
          </template>
        </template>

      </template>

      <template v-slot:cell()="celldata">
        <template v-if="celldata.value.goal">
          {{ celldata.value.svalue }}
          <span class="dot" :style="{ backgroundColor: ballColor(celldata.value.goal) }"></span>
        </template>
        <template v-else>
          {{ celldata.value }}
        </template>
      </template>

    </b-table>
    <b-pagination v-if="totalNumberRows>rowsPerPage" v-model="currentPage" :total-rows="totalNumberRows" :per-page="rowsPerPage"></b-pagination>
    <span>{{'TOTAL_ROWS' | i18n}}: {{totalNumberRows}} {{hiddenRowsText}}</span>
    <span v-if="nHiddenRows>0">&nbsp;({{nHiddenRows}} {{'ROWS_HIDDEN' | i18n}})</span>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import _ from 'lodash'
import ResultsService from "../../../services/ResultsService";
import DataRequester from "../../../datarequester";
import SimpleInterviewComponent from "@/views/interview/SimpleInterviewComponent";
import ComplexInterviewComponent from "@/views/interview/ComplexInterviewComponent";

export default {
  name: 'RankingTableWidget',

  components: {
    SimpleInterviewComponent, ComplexInterviewComponent
  },

  data() {
    return {
      sortBy: 'initial',
      sortDesc: false,
      fields: [],
      items: [],
      footerRow: [],

      // pagination
      currentPage: 1,
      totalNumberRows: null,
      nHiddenRows: null,
      rowsPerPage: 100,

      // filtering:
      filtertext: null,

      interviewResponse: null
    }
  },

  props: {
    widgetData: Object,
    dataRequester: Object
  },

  computed: {
    ...mapState(['activeStudy', 'activeView']),
    ...mapGetters(['absoluteDrillPath', 'completePath', 'realmName', 'studyName', 'authToken', 'pageByName', 'completePath']),
  },


  methods: {
    splitColumnHeader(title) {
      return title ? _.split(title, "_") : []
    },

    requestData(/*requester*/) {
    },

    myProvider(ctx, callback) {
//          const params = '?page=' + ctx.currentPage + '&size=' + ctx.perPage + " sortBy: " + ctx.sortBy + " sortDesc: " + ctx.sortDecs
      // console.log("Provider: " + params)

      // BBrequester.addChartRequest(this.dataCallback, this.widgetData.extname);

      const requester = new DataRequester("unused", this.completePath)
      requester.addPagedRankingTableRequest(this.widgetData.extname, ctx.currentPage, ctx.perPage, ctx.filter, ctx.sortBy, ctx.sortDesc)

      ResultsService.postDataRequest(this.authToken, this.realmName, this.studyName, requester).then((response) => {
        const responsesContainerDTO = response.data
        const tableResponseDTO = responsesContainerDTO.responses[0]

        if(tableResponseDTO.isInterviewDetails) {
          this.interviewResponse = tableResponseDTO
        } else {
          this.fields = tableResponseDTO.tableData.headers
          this.footerRow = tableResponseDTO.tableData.totalRow

          this.totalNumberRows = tableResponseDTO.tableData.totalNumberRows;
          this.nHiddenRows = tableResponseDTO.tableData.numberDrillFilteredRows
          callback(tableResponseDTO.tableData.rows)
        }

      })

      return null
    },


    onRowClicked(row) {
      if(/*!row["interviewExternId"] &&*/ row["path"]) {
        this.$store.commit('setCompleteDrillPath', row["path"])
      }
      // else if(row["interviewExternId"]) {
      //   console.log("Path")
      //   console.log(row["path"])
      //   this.$store.commit('setCompleteDrillPath', row["path"])
      //   PageNavigator.navigateToInterviewPage(this.$router, this.activeStudy.extname, row["path"])
      // }
      else {
//          console.log("Can't drill here")
      }

    },

    ballColor(goalType) {
      switch(goalType) {
        case 'GREEN':
          return '#29c43c'
        case 'YELLOW':
          return 'yellow'
        case 'ORANGE':
          return '#ffc000'
        case 'RED':
          return '#c00000'
      }

      return 'transparent'
    },

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.rankingTableWrapper {
  white-space: nowrap;
  padding: 0.5em;
  background-color: white;
}

thead.interviewtable {
  font-size: 8px;
}

.rankingTable tfoot tr {
  border-top: 2px solid black;
}

.drillColumnCell, .drillColumnHeader {
  text-align: left;
}

.levelColumnCell, .levelColumnHeader {
  padding-right: 1em !important;
  text-align: right;
}

.dot {
  height: 12px;
  width: 12px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
}


</style>
